import { Component } from '@angular/core';
import { NumberFieldComponent } from './number-field.component';

@Component( {
    selector: 'erp-pbw-hoch-note',
    templateUrl: './number-field.component.html'
} )
export class FinalGradeComponent extends NumberFieldComponent {

    constructor() {
        super( 'rm.erp.jobapplication.JobApplication.finalGrade',
            { minFractionDigits: 2, maxFractionDigits: 2 } );
    }

    set value( t: number | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.finalGrade = t;
        }
    }
    get value(): number | undefined {
        return this.jobapplication?.finalGrade;
    }
}
